import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const EditSubmitNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            d='M13.53 4.19656C13.7896 4.45619 13.7896 4.87714 13.53 5.13678L6.00006 12.6667L2.80369 9.47029C2.54395 9.21056 2.54395 8.78945 2.80369 8.52971C3.06319 8.27021 3.48386 8.26995 3.74369 8.52914L6.00006 10.78L12.59 4.19634C12.8496 3.93691 13.2704 3.93701 13.53 4.19656Z'
        />
    </svg>
));
